import React, { useEffect, useState, useContext } from "react";
import { db } from "../Firebase Functions/firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import styled from "styled-components";
import { AuthContext } from "../hooks/AuthProvider";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  padding: 1rem;
`;

const Card = styled.div`
  border: 1px solid #ddd;
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 5px;
  background: #f9f9f9;
`;

const ResumeButton = styled.button`
  background-color: #007820;
  color: white;
  padding: 0.4rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 0.75rem;
`;

const SavedDrafts = () => {
  const { currentUser } = useContext(AuthContext);
  const [drafts, setDrafts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDraftsByEmail = async () => {
      if (!currentUser?.email) return;

      try {
        const draftQuery = query(
          collection(db, "ChemAppForms"),
          where("status", "==", "draft"),
          where("applicatorEmail", "==", currentUser.email)
        );

        const snapshot = await getDocs(draftQuery);
        const results = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setDrafts(results);
      } catch (err) {
        console.error("❌ Error fetching drafts by email:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDraftsByEmail();
  }, [currentUser]);

  if (loading) return <p>Loading drafts...</p>;

  return (
    <Container>
      <h2>Saved Drafts</h2>
      {drafts.length === 0 ? (
        <p>No saved drafts found for your account.</p>
      ) : (
        drafts.map((draft) => (
          <Card key={draft.id}>
            <h3>{draft.project || "Unnamed Project"}</h3>
            <p><strong>Date:</strong> {draft.applicationDate || "N/A"}</p>
            <p><strong>Location:</strong> {draft.city || "—"}, {draft.state || "—"}</p>
            <p><strong>Status:</strong> {draft.status}</p>
            <ResumeButton onClick={() => navigate("/chem-app-form", { state: { draft } })}>
              Resume
            </ResumeButton>
          </Card>
        ))
      )}
    </Container>
  );
};

export default SavedDrafts;
